import { FunctionComponent, useState } from "react";
import { useDispatch, connect } from "react-redux";
import Loading from "../../Components/Loading/Loading";
import styles from "../AddOrganization/AddOrganization.module.css";
import { useLocation } from "react-router-dom";
import { themeColors } from "../../Components/theme";
import axios from "axios";
import { url } from "../../Values/constants";
import { showSnackbarAction } from "../../Redux/actions";
import "../../theme-vars.css";
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import StyledSubmitButton from "../../Components/Buttons/StyledSubmitButton";
import { Circles } from "react-loader-spinner";
import InputTextValue from "../../Components/TextInput/InputTextValue";

type props = {
  history: any;
  theme: any;
  user: any;
};

const EditHeaders: FunctionComponent<props> = ({ history, theme, user }) => {
  type MyObject = {
    label: string;
    value: string;
    is_mandatory: string;
    hide_field: string;
  };
  const dispatcher = useDispatch();
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));
  const location: any = useLocation();
  const [load, setLoad] = useState(false);
  const [inputValues, setInputValues] = useState<string[]>([]);
  const myArray: MyObject[] = location.state.detail.headers;

  const handleInputChange = (index: number, value: string, label: string) => {
    setInputValues(prevValues => {
      const newValues = [...prevValues];
      newValues[index] = value;
      return newValues;
    });
  };

  const renderBatch = (batch: MyObject[]) => {
    return (
      <Grid container spacing={isMobile ? 2 : 3}>
        {batch.map((obj, index) => (
          obj.hide_field === "false" && (
            <Grid
              item
              xs={12}    // full width on mobile
              sm={6}     // 2 per row on tablets
              md={4}     // 3 per row on medium screens
              lg={3}     // 4 per row on desktops
              key={index}
            >
              <InputTextValue
                title={obj.value}
                value={inputValues[index] || ""}
                onChange={(e) => handleInputChange(index, e.target.value, obj.label)}
                required={obj.is_mandatory === "true"}
              />
            </Grid>
          )
        ))}
      </Grid>
    );
  };

  const editOrganizationDetails = async (e: any, status: any) => {
    e.preventDefault();
    setLoad(true);

    const updatedArray = myArray.map((obj, index) => ({
      ...obj,
      value: inputValues[index] !== undefined ? inputValues[index] : obj.value,
    }));
    const apiData = {
      industry_id: location.state.detail.industry_id,
      screen_name: location.state.detail.screen_name,
      modified_by: user.user_email,
      status: status,
      headers: updatedArray,
      modified_at: new Date()
    };
    try {
      const res = await axios.patch(url + '/headers/updateHeaders', apiData);
      if (res.status == 200) {
        dispatcher(showSnackbarAction(res.data, "success"));
        const updateIndRes = await axios.post(url + '/headers/updateIndustryStatus', { industry_id: location.state.detail.industry_id });
        history.replace("/headers")
        setLoad(false);
      } else {
        dispatcher(showSnackbarAction(res.data, "error"));
        setLoad(false);
      }
      setInputValues([]);
      setLoad(false);
    } catch (e) {
      setLoad(false);
    }
  };
  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  const cardContainerStyles = { backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }

  return (
    <Box className={styles.parent} sx={{ ...containerStyles, marginTop: isMobile ? "6%" : "4%", fontFamily: "var(--font-family-main)" }}>
      {load && <Loading />}
      {isMobile && (
        <Box
          className="d-flex flex-row w-100 px-4 pt-4"
        >
          <h5
            style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-large)" }}
          >
            Edit Headers Name
          </h5>
        </Box>
      )}
      <Box
        className="w-100 d-flex flex-column gap-2 px-4"
        style={{
          padding: isMobile ? '0' : '',
          maxWidth: isMobile ? '100vw' : undefined,
          margin: isMobile ? '0' : '0 auto',
          overflowY: isMobile ? 'auto' : 'auto',
          maxHeight: isMobile ? 'calc(100vh - 120px)' : 'calc(100vh - 60px)',
        }}
      >
        <form
          className={`card shadow rounded mt-2${!isMobile ? ` ${styles.forcePadding}` : ""}`}
          style={{
            ...cardContainerStyles,
            padding: isMobile ? '16px' : '32px',
            boxSizing: 'border-box',
            minHeight: isMobile ? 'auto' : undefined,
            marginBottom: 16
          }}
        >
          {renderBatch(myArray)}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 1, // space between buttons
              marginTop: "20px",
            }}
          >
            <Box>
              <StyledSubmitButton
                onClick={(e: any) => editOrganizationDetails(e, "InReview")}
                themeMode={themeMUI.palette.mode}
                isMobile={isMobile}
              >
                {load ? <Circles height={20} width={20} /> : "InReview"}
              </StyledSubmitButton>
            </Box>
            <Box>
              <StyledSubmitButton
                onClick={(e: any) => editOrganizationDetails(e, "Launched")}
                themeMode={themeMUI.palette.mode}
                isMobile={isMobile}
              >
                {load ? <Circles height={20} width={20} /> : "Launch"}
              </StyledSubmitButton>
            </Box>
          </Box>
        </form>
      </Box>
    </Box>
  );
};

const mapStateToProps = (state: any) => {
  return {
    theme: state.theme.isLightMode,
    user: state.user.data
  };
};

export default connect(mapStateToProps)(EditHeaders);

